import { Component, Inject } from '@angular/core';
import { PriceVersion, SalesDocument } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { Subscription } from 'rxjs';
import { PriceVersionService } from '../price-version-selector/price-version.service';

@Component({
    selector: 'icc-price-version-dialog',
    templateUrl: './price-version-dialog.component.html',
    styleUrls: ['./price-version-dialog.component.scss'],
})
export class PriceVersionDialogComponent {

    activatedPriceVersion: PriceVersion;

    private subscriptions: Subscription[] = [];

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            priceUpdatePending: boolean;
            invalidVersion: boolean;
        },
        private dialogRef: DialogRef,
        private priceVersionService: PriceVersionService,
    ) {
        this.priceVersionService.checkActivePriceVersion();
        this.subscriptions.push(
            this.priceVersionService.activatedPriceVersion$.subscribe(priceVersion => {
                if (priceVersion?.id){
                    this.activatedPriceVersion = priceVersion;
                }
            }),
        );
	}

    changedPriceVersion(priceVersion: PriceVersion) {
        this.activatedPriceVersion = priceVersion;
    }

    close() {
        this.dialogRef.close();
    }

    change() {
        this.dialogRef.close({
            id: this.activatedPriceVersion?.id,
        });
    }
}
